<template>
  <div class="content">
    <div class="biaoti">测试结果</div>
    <div class="title">
      {{data[0].type}}
    </div>
    <div class="main">
      <div>
        {{data[0].part1}}
      </div>
      <div>
        {{data[0].part2}}
      </div>
      <div>
        {{data[0].part3}}
      </div>
    </div>
    <div class="title">
      {{data[1].type}}
    </div>
    <div class="main">
      <div>
        {{data[1].part1}}
      </div>
      <div>
        {{data[1].part2}}
      </div>
      <div>
        {{data[1].part3}}
      </div>
    </div>
    <div class="title">
      {{data[2].type}}
    </div>
    <div class="main">
      <div>
        {{data[2].part1}}
      </div>
      <div>
        {{data[2].part2}}
      </div>
      <div>
        {{data[2].part3}}
      </div>
    </div>
    <div class="line">

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        result: []
      }
    },
    created() {
      let result = this.$route.query.result.split(',')
      //this.result =result.sort((a, b) => b - a);
      this.$http.testHollandResult({
        type: result
      }).then(res => {
        this.data = res.data
      })
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .content {
    width: 1280px;
    margin: 0 auto;
  }

  .title {
    margin-bottom: 10px;
  }

  .biaoti {
    font-size: 30px;
    margin: 30px 0;
  }

  .main {
    margin: 20px 10px 30px 10px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/view/test/huolandeResult.vue